import React from "react";
import ReactDOM from "react-dom/client";
import { Provider } from "react-redux";
import { ExternosElectronico } from "./externosElectronico";
import { store } from "./store/store";
import "./index.css";
import "./styles/style.css";
import "./styles/loading/loading.css";
import "./styles/loading/loading2.css";
import "./styles/circlesAnimation/circles.css";
import "./styles/successIconStyle/succesIconStyle.css";
import "animate.css";
import "primereact/resources/primereact.min.css";
import "primeicons/primeicons.css";

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);

console.log("%c Detente", "color: red; font-size: 40px");
console.log(
  "%c Está funcion del navegador esta pensada para desarrolladores, si sigues navegado sobre el inspector puedes llegar a comprometer datos que terminen afectando el buen funcionamiento del sistema",
  "color: green; font-size: 20px"
);

root.render(
  // <React.StrictMode>
  <Provider store={store}>
    <ExternosElectronico />
  </Provider>
  // </React.StrictMode>
);
